import type { Address } from "../../../../models/address"

export const getSiteAddress = (address: Address | undefined) => {
  if (address) {
    return `${address.address_line_1 ?? ""} ${address.address_line_2 ?? ""} ${
      address.city ?? ""
    } ${address.state ?? ""} ${address.postal_code ?? ""} ${
      address.country ?? ""
    }`
  }
  return null
}
